export default {"src":"/_next/static/media/empty-state-events.5f5f9f28.svg","height":93,"width":96,"blurWidth":0,"blurHeight":0};